import React from "react";
import RegistrationForm from "./components/RegistrationForm";
import { LocalizationProvider } from "@mui/x-date-pickers";
import skLocale from "date-fns/locale/sk"; // Import Slovak locale
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const AppRegistrationForm = () => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={skLocale}>
            <RegistrationForm />
        </LocalizationProvider>
    );
};

export default AppRegistrationForm;
